/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type TriggerEnvRequirement = {
  /**
   * Description of the variable.
   */
  description?: string | undefined;
  /**
   * The environment variable name.
   */
  name: string;
  /**
   * Whether the variable is required.
   */
  required: boolean;
};

/** @internal */
export const TriggerEnvRequirement$inboundSchema: z.ZodMiniType<
  TriggerEnvRequirement,
  unknown
> = z.object({
  description: z.optional(z.string()),
  name: z.string(),
  required: z.boolean(),
});

export function triggerEnvRequirementFromJSON(
  jsonString: string,
): SafeParseResult<TriggerEnvRequirement, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TriggerEnvRequirement$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TriggerEnvRequirement' from JSON`,
  );
}
